<div class="relative flex flex-col grid-cols-1 gap-y-2 ">
    <!-- Gradient Banner -->
    <div class="relative h-12 bg-white dark:bg-zinc-900 rounded-full shadow overflow-hidden">
        @if (searchColour && searchColour === 'purple') {
        <img class="absolute inset-0 w-full h-full object-cover"
            src="../../../../../assets/welcome/purple-search-door.png" alt="">
        }
        @if (searchColour && searchColour === 'pink') {
        <img class="absolute inset-0 w-full h-full object-cover"
            src="../../../../../assets/welcome/pink-search-door.png" alt="">
        }
        @if (searchColour && searchColour === 'blue') {
        <img class="absolute inset-0 w-full h-full object-cover"
            src="../../../../../assets/welcome/blue-search-door.png" alt="">
        }

        @if (showPartial) {
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="absolute top-2 left-2 size-4 text-white-force z-10">
            <path d="M12 3v18" />
            <path d="m19 8 3 8a5 5 0 0 1-6 0zV7" />
            <path d="M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1" />
            <path d="m5 8 3 8a5 5 0 0 1-6 0zV7" />
            <path d="M7 21h10" />
        </svg>
        }



        <div class="absolute right-2 top-1/2 -translate-y-1/2 flex flex-row gap-x-2 items-center justify-end w-full">

            @if (!socialScreeningService.selectedCreators().includes(creator)) {
            <button (click)="socialScreeningService.selectCreator(creator)" type="button"
                class=" z-10 text-white secondary-button-full">Screen</button>
            } @else {
            <span (click)="socialScreeningService.removeCreator(creator)"
                class=" z-10 inline-flex items-center gap-x-1.5 text-white secondary-button-full">
                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1.5 fill-teal-500">
                    <circle r="3" cx="3" cy="3" />
                </svg>
                Un-Select
            </span>
            }



            <!-- Collaborate Button -->
            @if (!collaboratorsService.selectedCreators().includes(creator)) {
            <button (click)="collaboratorsService.selectCreator(creator)" type="button"
                class=" z-10 text-white secondary-button-full">Collaborate</button>
            } @else {
            <span (click)="collaboratorsService.removeCreator(creator)"
                class=" z-10 inline-flex items-center gap-x-1.5 text-white secondary-button-full">
                <svg viewBox="0 0 6 6" aria-hidden="true" class="size-1.5 fill-primary">
                    <circle r="3" cx="3" cy="3" />
                </svg>
                Un-Select
            </span>
            }
            <!-- Collaborate Button END -->
        </div>

    </div>
    <!-- Gradient Banner END -->

    <!-- Profile Card -->
    <div (click)="launchPortfolio()" class="bg-white/50 dark:bg-white/5 rounded-lg p-2 flex flex-col gap-y-2">
        <!-- Picture and action btn -->
        <div class="flex flex-row w-full items-center justify-between">
            <div
                class="-mt-8 sm:-mt-12 shrink-0 size-16 sm:size-24 rounded-full outline-1 -outline-offset-1 outline-black/5 dark:outline-white/10">
                <atom-ldg-img inputClass="object-cover" w="full" h="full" radius="full"
                    [src]="imageService.getImageSource(creator.photoURL, 'gallery_xl')"
                    [aspect]="'aspect-square'"></atom-ldg-img>
            </div>

            <div class="flex flex-row divide-x divide-gray-200 dark:divide-gray-700">

                <div class="flex flex-col items-center justify-center px-2">
                    <p class="text-sm font-bold text-primary">{{
                        formatService.convertIntToString(getAverageViews()) }}
                    <p class="text-xxs text-gray-500 dark:text-gray-400 inline-flex gap-1.5 items-center">Avg.
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path
                                d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                    </p>
                </div>
                <div class="flex flex-col items-center justify-center pl-2">
                    <p class="text-sm font-bold text-primary">{{
                        formatService.convertIntToString(getAvgEngaegement()) }}
                    <p class="text-xxs text-gray-500 dark:text-gray-400 inline-flex gap-1.5 items-center">Avg.
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-4">
                            <path
                                d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20" />
                            <path
                                d="M8.62 9.8A2.25 2.25 0 1 1 12 6.836a2.25 2.25 0 1 1 3.38 2.966l-2.626 2.856a.998.998 0 0 1-1.507 0z" />
                        </svg>
                    </p>
                </div>
            </div>
        </div>
        <!-- Picture and action btn END -->

        <!-- Name Row -->
        <div class="flex flex-row w-full items-center justify-between overflow-hidden gap-x-2">
            <div class="flex-1 flex flex-col items-start overflow-hidden">
                <div class="inline-flex gap-x-2 items-center">
                    <p class="text-md text-primary">{{ creator.firstName }} {{ creator.lastName.charAt(0) }}.</p>
                    @if (creator.isVerified) {
                    <span class="">
                        <img class="h-4" src="../../../../../assets/social-icon/verified_badge.svg" alt="" />
                    </span>
                    }
                </div>
                <p class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ getFlag() }} {{ creator.homeTownName ?
                    creator.homeTownName : 'Unset' }}</p>
            </div>
            <!-- <div class="shrink-0 text-transparent">RHS</div> -->
            <div class="shrink-0 inline-flex gap-1.5 items-center pr-2 text-primary">
                <p class="text-lg font-bold">{{ creator.reviews_summary?.average_rating | number:'1.1-1' }}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4">
                    <path
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
                </svg>
            </div>
        </div>
        <!-- Name Row -->

        <!-- About Row -->
        @if (showAbout) {
        <div class="flex flex-col w-full justify-start items-start">
            <h4 class="text-sm font-bold text-primary">About</h4>
            <p class="text-xs text-gray-500 dark:text-gray-400 line-clamp-2 h-[2lh]">{{ creator.bio }}</p>

        </div>
        }
        <!-- About Row -->

        <!-- Socials Row -->
        <div class="flex flex-row w-full items-center justify-between">
            <div class="flex items-center gap-1">
                <img class="h-4 w-4 sm:h-5 sm:w-5" src="../../../../../assets/social-icon/tik-tok-transparent.svg"
                    alt="TikTok">
                <p class="text-[10px] sm:text-sm text-primary font-medium">
                    {{ (creator.tikTokFollowers && creator.tikTokFollowers > 0) ?
                    (creator.tikTokFollowers |
                    shortNumber) : '-' }}
                </p>
            </div>
            <div class="flex items-center gap-1">
                <img class="h-4 w-4 sm:h-5 sm:w-5" src="../../../../../assets/social-icon/instagram-logo.png"
                    alt="Instagram">
                <p class="text-[10px] sm:text-sm text-primary font-medium">
                    {{ (creator.instaFollowers && creator.instaFollowers > 0) ?
                    (creator.instaFollowers |
                    shortNumber) : '-' }}
                </p>
            </div>
            <div class="flex items-center gap-1">
                <img class="h-4 w-4 sm:h-5 sm:w-5" src="../../../../../assets/social-icon/snapchat-logo.svg"
                    alt="Snapchat">
                <p class="text-[10px] sm:text-sm text-primary font-medium">
                    {{
                    (creator.snapchatFollowers && creator.snapchatFollowers > 0) ?
                    (creator.snapchatFollowers |
                    shortNumber) :
                    '-'
                    }}
                </p>
            </div>
        </div>
        <!-- Socials Row -->
    </div>
    <!-- Profile Card END -->
</div>